var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTransferAccountLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1579 16.2586L15.1579 14.5744L7.18861 14.5744L7.18861 12.3844L1.93965 15.4149L7.18861 18.4454L7.18861 16.2586L15.1579 16.2586Z",
    fill: "#02B27F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.85588 9.44304L8.85588 7.73128L16.5968 7.73128L16.5968 5.63249L21.8457 8.66298L16.5968 11.6935L16.5968 9.44304L8.85588 9.44304Z",
    fill: "#F2AE00"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferAccountLight);
export default __webpack_public_path__ + "static/media/transfer_accountLight.eb29bd0891548f8ccef58adc6633a68d.svg";
export { ForwardRef as ReactComponent };